<template>
    <div>
        <!-- 合作伙伴-->
        <div class="head-label box-shadow-class-left">
            {{ $t('common.partner') }}
        </div>
        <div style="display: flex;justify-content: space-between;margin: 20px 0;align-items: center;">
            <img src="../assets/没有地址.gif" style="height: 200px;width:200px;margin-right: 20px;" />
            <div style="margin-top: 20px;">
                <div class="box-shadow-class-right" style="background-color: #0c1433;
    padding:30px 20px;width: 100%;border-radius: 20px; min-height: 80px;box-sizing: border-box;">
                    <div>{{ $t('common.gongSi1') }}：{{ $t('common.gongSi7') }}</div>
                    <div>{{ $t('common.gongSi3') }}：{{ $t('common.gongSi8') }}</div>
                </div>
            </div>
        </div>

        <div style="display: flex;justify-content: space-between;margin: 20px 0;align-items: center;">
            <div class="box-shadow-class-left" style="background-color: #0c1433;
    padding:30px 20px;width: 100%;border-radius: 20px;">
                <div>{{ $t('common.gongSi1') }}：{{ $t('common.gongSi2') }}</div>
                <div>{{ $t('common.gongSi3') }}：{{ $t('common.gongSi4') }}</div>
            </div>
            <img src="../assets/没有地址.gif" style="height: 200px;width:200px;margin-left: 20px;" />
        </div>
        <div style="display: flex;justify-content: space-between;margin: 20px 0;align-items: center;">
            <img src="../assets/没有地址.gif" style="height: 200px;width:200px;margin-right: 20px;" />
            <div class="box-shadow-class-right" style="background-color: #0c1433;
    padding:30px 20px;width: 100%;border-radius: 20px;">
                <div>{{ $t('common.gongSi1') }}：{{ $t('common.gongSi5') }}</div>
                <div>{{ $t('common.gongSi3') }}：{{ $t('common.gongSi6') }}</div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
        }
    },
    methods: {},
    mounted() {
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        },

    },
}
</script>

<style scoped>
.box-shadow-class-right {
    box-shadow: 10px 10px 0px #409eff;
    border: 3px solid #666;
    box-sizing: border-box;
}

.box-shadow-class-left {
    box-shadow: -10px 10px 0px #409eff;
    border: 3px solid #666;
    box-sizing: border-box;
}

.head-label {
    width: 100%;
    display: flex;
    margin-top: 10px;
    font-size: 1.5em;
    font-weight: bold;
    justify-content: center;
    background-color: #0c1433;
    border-radius: 20px;
    padding: 30px 20px;
    box-sizing: border-box;
}


</style>